import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BRAND } from "../data/brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Welcome to the Voyage Luxe circle.");
      setEmail("");
    } catch (err) {
      toast.error("Please check your email and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-secondary text-foreground border-t border-border">
      <div className="container-luxe py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="font-serif text-3xl tracking-[0.05em] leading-none">VOYAGE LUXE</div>
            <div className="eyebrow mt-2">Est. {BRAND.founded} · India</div>
            <p className="mt-8 text-foreground/70 max-w-md leading-relaxed">
              A private destination management atelier curating the finest journeys across India and the wider world — for guests for whom ordinary will not do.
            </p>

            <form onSubmit={subscribe} className="mt-10 max-w-md" data-testid="newsletter-form">
              <div className="eyebrow mb-3">The Concierge Letter</div>
              <div className="flex items-center border-b border-foreground/30 focus-within:border-accent transition-colors">
                <input
                  type="email"
                  required
                  data-testid="newsletter-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="bg-transparent flex-1 py-3 outline-none text-sm placeholder:text-foreground/40"
                />
                <button
                  type="submit"
                  disabled={loading}
                  data-testid="newsletter-submit"
                  className="uppercase text-[11px] tracking-[0.25em] py-3 px-4 text-foreground/70 hover:text-accent transition-colors disabled:opacity-50"
                >
                  {loading ? "…" : "Subscribe"}
                </button>
              </div>
              <p className="mt-2 text-[11px] text-foreground/40">Quarterly. Never shared. Always considered.</p>
            </form>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-3">
            <div className="eyebrow mb-5">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/destinations" className="hover:text-accent transition-colors">Destinations</Link></li>
              <li><Link to="/destinations/rajasthan" className="hover:text-accent transition-colors">Rajasthan</Link></li>
              <li><Link to="/destinations/maldives" className="hover:text-accent transition-colors">Maldives</Link></li>
              <li><Link to="/destinations/japan" className="hover:text-accent transition-colors">Japan</Link></li>
              <li><Link to="/experiences" className="hover:text-accent transition-colors">Signature Experiences</Link></li>
              <li><Link to="/journal" className="hover:text-accent transition-colors">The Journal</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow mb-5">Atelier</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-accent transition-colors">Our Story</Link></li>
              <li><Link to="/contact" className="hover:text-accent transition-colors">Concierge</Link></li>
              <li><a href="#" className="hover:text-accent transition-colors">Press</a></li>
              <li><a href="#" className="hover:text-accent transition-colors">Careers</a></li>
              <li><Link to="/testimonials" className="hover:text-accent transition-colors">Testimonials</Link></li>
              <li><Link to="/privacy" className="hover:text-accent transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-accent transition-colors">Terms</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-foreground/70">
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 shrink-0" strokeWidth={1.25} /><span>{BRAND.address}</span></li>
              <li className="flex items-center gap-2"><Phone size={14} strokeWidth={1.25} /><a href={BRAND.phone_link} className="hover:text-accent">{BRAND.phone}</a></li>
              <li className="flex items-center gap-2"><Mail size={14} strokeWidth={1.25} /><a href={`mailto:${BRAND.email}`} className="hover:text-accent">{BRAND.email}</a></li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a href={BRAND.social.instagram} aria-label="Instagram" className="hover:text-accent"><Instagram size={16} strokeWidth={1.25} /></a>
              <a href={BRAND.social.facebook} aria-label="Facebook" className="hover:text-accent"><Facebook size={16} strokeWidth={1.25} /></a>
              <a href={BRAND.social.linkedin} aria-label="LinkedIn" className="hover:text-accent"><Linkedin size={16} strokeWidth={1.25} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-foreground/50">
          <div>© {new Date().getFullYear()} Voyage Luxe Travel Atelier. All rights reserved.</div>
          <div className="eyebrow">A Member of the World Luxury Travel Forum</div>
        </div>
      </div>
    </footer>
  );
}
